module.exports = __webpack_public_path__ + "static/media/port_marker_light_blue.58a88633.svg";